import { TestOpsCommandLogo } from '@ytest/testops-command'

const YTEST_URL = import.meta.env.VITE_YTEST_URL || 'https://ytest.ai'
const ATHENA_URL = import.meta.env.VITE_ATHENA_URL || 'https://athena.ytest.ai'
const TOUCAN_URL = import.meta.env.VITE_TOUCAN_URL || 'https://toucan.ytest.ai'

const links = {
  Product: [
    { label: 'Capabilities', href: '#capabilities' },
    { label: 'Integrations', href: '#integrations' },
    { label: 'How it works', href: '#how-it-works' },
    { label: 'Contact', href: '#contact' },
  ],
  Platform: [
    { label: 'ytest.ai', href: YTEST_URL },
    { label: 'Toucan', href: TOUCAN_URL },
    { label: 'Athena', href: ATHENA_URL },
    { label: 'All products', href: `${YTEST_URL}/products` },
  ],
  Company: [
    { label: 'About', href: `${YTEST_URL}/#about` },
    { label: 'Contact', href: 'mailto:hello@ytest.ai' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: `${YTEST_URL}/privacy-policy` },
    { label: 'Terms of Service', href: `${YTEST_URL}/terms-of-service` },
    { label: 'Cookie Policy', href: `${YTEST_URL}/cookie-policy` },
    { label: 'Security', href: `${YTEST_URL}/security` },
  ],
}

export function Footer() {
  return (
    <footer className="border-t border-white/5 bg-black py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:grid-cols-5">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <TestOpsCommandLogo size={28} />
              <span className="font-mono text-sm font-semibold text-white">
                TestOps Command
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-white/70">
              The AI command center for your testing org.
              Part of the ytest.ai platform.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(links).map(([heading, items]) => (
            <div key={heading}>
              <h3 className="font-mono text-xs font-semibold uppercase tracking-widest text-white/70">
                {heading}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-sm text-white/70 transition hover:text-white"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-8 text-xs text-white/60 sm:flex-row sm:items-center">
          <p className="font-mono">
            &copy; {new Date().getFullYear()} ytest.ai &middot; built for the command line of test ops
          </p>
          <p className="font-mono">
            $ <span className="text-cyan-300">ytest</span> --product testops-command
          </p>
        </div>
      </div>
    </footer>
  )
}
